<template>
  <div class="account truewallet">
    <div class="columns is-mobile">
      <div class="column is-5 is-one-third-mobile text-center">
        <img src="@/assets/logo/truewallet.png" width="100" />
      </div>
      <div class="column is-7 is-two-third-mobile">
        <div class="bank-detail">
          <div class="bank-name-th m-t-10">
            Truewallet
          </div>
          <div class="account-no">
            {{ walletAccounts[0].walletAccountName | bankAccountFormat }}
            <i
              class="fas fa-copy m-l-10"
              v-clipboard:copy="walletAccounts[0].walletAccountName"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            ></i>
          </div>
          <div class="m-t-20 bank-name-en">
            {{ $t('modals.deposit.conditionTrueWalletAuto') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalDeposit',
  props: {
    walletAccounts: {
      type: Array
    }
  },
  data() {
    return {}
  },
  methods: {
    onCopy(e) {
      this.$buefy.toast.open({
        message: `Copied: ${e.text}`,
        type: 'is-success'
      })
    },
    onError() {
      this.$buefy.toast.open({
        message: 'Failed to copy',
        type: 'is-danger'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.box-link {
  text-align: center;
  padding: 15px;
  border-radius: 10px;
  color: white;
  margin: 10px 0;

  img {
    width: 100%;
    max-width: 250px;
  }
}

.truewallet {
  background: linear-gradient(#d83b34 25%, #e3783c 100%);
}
</style>
